<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        :loading="loading"
        @save="$refs.Form.handleSave()"
        large
        ref="Modal"
        title="Novo lote"
    >
        <Form
            :data="data"
            @save="$emit('save', $event)"
            ref="Form"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    methods: {
        open() {

            this.$refs.Modal.show()
        },
        close() {

            this.$refs.Modal.hide()
        },
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>